module.exports = __webpack_public_path__ + "img/ca-bc.ff7a4c19.svg";